"use client";
import Aos from "aos";
import "aos/dist/aos.css";
import "../styles/index.scss";
import { useEffect, Suspense } from "react";
import ScrollToTop from "../components/common/ScrollTop";
import { Provider } from "react-redux";
import { store } from "../store/store";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { GoogleTagManager } from "@next/third-parties/google";
import { UserProvide } from "@/context/UserProvide";
import Script from "next/script";
import FloatButton from "@/components/float-button";
import ReferralCode from "@/components/reffer/RefferCode";
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

if (typeof window !== "undefined") {
  require("bootstrap/dist/js/bootstrap");
}

export default function RootLayout({ children }) {
  useEffect(() => {
    Aos.init({
      duration: 1400,
      once: true,
    });
  }, []);

  return (
    <html lang="en">
      <head>
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css2?family=Jost:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap"
        />
        <meta name="robots" content="max-image-preview:large,index, follow" />
        <meta httpEquiv="x-ua-compatible" content="ie=edge" />
        <meta
          name="keywords"
          content="candidates, career, employment, indeed, job board, job listing, job portal, job postings, job search, job seeker, jobs, recruiters, recruiting, recruitment, resume"
        />
        <meta name="description" content="Job24h" />
        <meta name="ibthemes" content="ATFN" />
        <link
          rel="icon"
          href="/images/logo.png?<generated>"
          type="image/<generated>"
          sizes="<generated>"
        />
      </head>

      <body>
        <Provider store={store}>
          <div className="page-wrapper">
             <GoogleReCaptchaProvider
                reCaptchaKey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}
                scriptProps={{
                  async: false,
                  defer: false,
                  appendTo: "head",
                  nonce: undefined,
                }}
              >
              <UserProvide>
                <Suspense fallback={null}>
                  <ReferralCode />
                </Suspense>
                {children}
                <div 
                  class="zalo-chat-widget" 
                  data-oaid="1730179207335957596" 
                  data-welcome-message="Chào anh/chị! Em là Mạnh Nguyễn - chuyên viên tư vấn xuất khẩu lao động và du học của Job24H.VN!  Rất vui được hỗ trợ anh/chị hôm nay!"
                   data-autopopup="0" 
                   data-width="300" 
                   data-height="500"
                />
                <ToastContainer
                  position="top-right"
                  autoClose={1500}
                  hideProgressBar={false}
                  newestOnTop={false}
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                  theme="colored"
                />
                <ScrollToTop />
                <FloatButton />
              </UserProvide>
            </GoogleReCaptchaProvider>
          </div>
        </Provider>
      </body>
      <Script src="https://sp.zalo.me/plugins/sdk.js"></Script>
      <GoogleTagManager gtmId="GTM-MWP2DQPC" />
    </html>
  );
}
